import { render, staticRenderFns } from "./templateAsset.vue?vue&type=template&id=46ef835c&"
import script from "./templateAsset.vue?vue&type=script&lang=ts&"
export * from "./templateAsset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports